import type { SliderSchemaType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import type { ElementStyleCss } from 'services/Branding/types'

const ListItemStyled = styled.li<{
  $styles: ElementStyleCss<SliderSchemaType>
}>`
  list-style: none;

  &:first-child {
    margin: 0;
  }

  &:first-child {
    margin: 0;
  }

  ${({ $styles: { progress } }) => css`
    margin-left: ${progress.marginLeft};
  `}
`

export default ListItemStyled
